import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import skjLogo from "../../assets/skj_logo.jpeg";

import {
  FiHome,
  FiUsers,
  FiPackage,
  FiLayers,
  FiTrendingUp,
  FiTrendingDown,
  FiFileText,
  FiPrinter,
  FiSettings,
  FiBarChart2,
  FiShoppingCart
} from 'react-icons/fi';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const { user } = useAuth();

  const navItems = [
    { name: 'Dashboard', path: '/dashboard', icon: FiHome, permission: null },
    { name: 'Categories', path: '/categories', icon: FiLayers, permission: 'categories' },
    { name: 'Sub-Categories', path: '/sub-categories', icon: FiLayers, permission: 'categories' },
    { name: 'Products', path: '/products', icon: FiPackage, permission: 'products' },
    { name: 'Stock In', path: '/stock-in', icon: FiTrendingUp, permission: 'stock' },
    // { name: 'Stock Out', path: '/stock-out', icon: FiTrendingDown, permission: 'stock' },
    { name: 'Invoices', path: '/invoices', icon: FiFileText, permission: 'invoices' },
    { name: 'Purchase Bills', path: '/purchase-bills', icon: FiShoppingCart, permission: 'purchase_bills' },
    { name: 'Printing / Branding', path: '/printing-branding', icon: FiPrinter, permission: 'printing_branding' },
    { name: 'Reports', path: '/reports', icon: FiBarChart2, permission: 'reports' },
    { name: 'Users', path: '/users', icon: FiUsers, permission: 'users', adminOnly: true },
    { name: 'Settings', path: '/settings', icon: FiSettings, permission: null }
  ];

  const filteredNavItems = navItems.filter(item => {
    if (item.adminOnly && user?.role !== 'admin') return false;
    return true;
  });

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={toggleSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-30 h-screen bg-gradient-to-b from-gray-800 to-gray-900 text-white transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } lg:translate-x-0 w-64`}
      >
        {/* Logo */}
        {/* <div className="flex items-center justify-center h-16 border-b border-gray-700 bg-gray-900">
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg">
              <FiPackage className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-lg font-bold">SKJ Creations</h1>
              <p className="text-xs text-gray-400">Inventory System</p>
            </div>
          </div>
        </div> */}
        <div className="flex items-center justify-center h-16 border-b border-gray-700 bg-gray-900">
          <div className="flex items-center space-x-2">
            <div className=" bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg">
              <img
                src={skjLogo}   // public/logo.png
                alt="SKJ Creations Logo"
                
                className="w-12 h-12 object-contain rounded-lg"
              />
            </div>
            <div>
              <h1 className="text-lg font-bold">SKJ Creations</h1>
              <p className="text-xs text-gray-400">Inventory System</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="mt-6 px-4 pb-5 space-y-2 overflow-y-auto h-[calc(100vh-4rem)]" style={{ paddingBottom: "5rem" }}>
          {filteredNavItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 ${isActive
                  ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`
              }
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.name}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
